import React from 'react';

export function Select({ label, options = [], value, placeholder = 'Select…', onChange, disabled = false, hint }) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  const selected = options.find((o) => o.value === value);
  React.useEffect(() => {
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);
  return (
    <div ref={ref} style={{ display: 'grid', gap: '6px', position: 'relative' }}>
      {label && <label style={{ fontSize: 'var(--fs-body-sm)', fontWeight: 500, color: 'var(--text-1)' }}>{label}</label>}
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px',
          height: '40px', padding: '0 14px', borderRadius: 'var(--radius-md)',
          border: `1px solid ${open ? 'var(--focus-ring-color)' : 'var(--border-strong)'}`,
          boxShadow: open ? 'var(--focus-ring-shadow)' : 'none',
          background: disabled ? 'var(--surface-2)' : 'var(--surface-1)', color: selected ? 'var(--text-1)' : 'var(--text-muted)',
          font: 'inherit', fontSize: 'var(--fs-body-md)', cursor: disabled ? 'not-allowed' : 'pointer', width: '100%',
        }}
      >
        <span>{selected ? selected.label : placeholder}</span>
        <span style={{ opacity: .6, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform var(--duration-fast)' }}>▾</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, zIndex: 20,
          background: 'var(--surface-1)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)',
          boxShadow: 'var(--shadow-lg)', padding: '6px', maxHeight: '240px', overflowY: 'auto',
        }}>
          {options.map((o) => (
            <div key={o.value}
              onClick={() => { onChange && onChange(o.value); setOpen(false); }}
              style={{ padding: '9px 12px', borderRadius: 'var(--radius-sm)', fontSize: 'var(--fs-body-md)', cursor: 'pointer', background: o.value === value ? 'var(--brand-primary-soft)' : 'transparent', color: o.value === value ? 'var(--brand-primary-ink)' : 'var(--text-1)' }}
              onMouseEnter={(e) => { if (o.value !== value) e.currentTarget.style.background = 'var(--surface-2)'; }}
              onMouseLeave={(e) => { if (o.value !== value) e.currentTarget.style.background = 'transparent'; }}
            >{o.label}</div>
          ))}
        </div>
      )}
      {hint && <span style={{ fontSize: 'var(--fs-caption)', color: 'var(--text-muted)' }}>{hint}</span>}
    </div>
  );
}
